import React from "react";
import { baseUrl } from "./api/imageService";
import "./App.css";

const AboutMe: React.FC = () => {
  return (
    <div className="about-me-container">
      <video
        controls
        className="about-me-video"
        src={`${baseUrl}/cv/about-me.mp4`}
      >
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default AboutMe;
